import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { findAll } from "@/apis/template";
import Router from "@/constants/router";
import { TemplateDto } from "@/dto/TemplatesDto";

export default function useList() {
  const navigate = useNavigate();
  const [templateList, setTemplateList] = useState<TemplateDto[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [selectedProductId, setSelectedProductId] = useState<string>("1"); // 기본값은 Starter

  const handleGoToCreate = () => {
    navigate(Router.TemplateCreate);
  };

  const fetchData = useCallback(async (productId: string = "1") => {
    try {
      setIsLoading(true);
      const res = await findAll(productId);
      if (res.success) {
        setTemplateList(res.data);
      }
    } catch (e) {
      console.error(e);
    } finally {
      setIsLoading(false);
    }
  }, []);

  // 필터 변경 처리
  const handleFilterChange = (productId: string) => {
    setSelectedProductId(productId);
    fetchData(productId);
  };

  useEffect(() => {
    fetchData(selectedProductId);
  }, [fetchData, selectedProductId]);

  return {
    isLoading,
    templateList,
    handleGoToCreate,
    handleFilterChange,
    selectedProductId,
  };
}
